import { selectIsReactBEEBuilderTemplatesFeatureFlagOn } from 'core/userContext/selectors';
import { DRAG_AND_DROP_TEMPLATES_URL } from 'modules/templateEditor/common/constants';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RestQueryHookOptions, useRestQuery } from 'utils/hooks/api/useRestQuery';

export type QueryDragAndDropTemplatesResponse = {
  json?: any;
  slug: string;
  templateTitle?: string;
  title?: string;
  description: string;
  thumbnail?: string;
};

/**
 * Returns a list of Bee editor templates
 */
export const useQueryDragAndDropTemplates = (
  options?: RestQueryHookOptions<ReadonlyArray<QueryDragAndDropTemplatesResponse>>,
) => {
  const [templates, setTemplates] = useState<QueryDragAndDropTemplatesResponse[]>([]);
  const [isLoadingTemplates, setIsLoadingTemplates] = useState(false);
  const isFFOn = useSelector(selectIsReactBEEBuilderTemplatesFeatureFlagOn);

  const {
    isFetching: isLoading,
    data,
    refetch,
  } = useRestQuery(DRAG_AND_DROP_TEMPLATES_URL, undefined, {
    refetchOnWindowFocus: false,
    staleTime: Infinity, // This data never change and should be cached until the user reloads the page
    ...options,
    enabled: false,
  });

  if (isFFOn) {
    return {
      isLoading: isLoadingTemplates,
      dragAndDropTemplates: templates as ReadonlyArray<QueryDragAndDropTemplatesResponse>,
      refetch: () => {
        setIsLoadingTemplates(true);
        import('modules/templateEditor/common/templates/templates')
          .then(({ DRAG_AND_DROP_TEMPLATES }) => {
            setTemplates(
              Object.keys(DRAG_AND_DROP_TEMPLATES).map((key) => ({
                slug: key,
                json: DRAG_AND_DROP_TEMPLATES[key],
                description: '',
              })),
            );
          })
          .catch((e) => {
            options?.onError?.(e);
          })
          .finally(() => setIsLoadingTemplates(false));
      },
    };
  }

  return {
    isLoading,
    dragAndDropTemplates: data as ReadonlyArray<QueryDragAndDropTemplatesResponse>,
    refetch,
  };
};
